module.exports = __webpack_public_path__ + "img/YP.8cdb4b6c.png";